import styled from 'styled-components';

import { ANIM, COLORS } from '@/nova/theme/tokens';

// Bare, compact icon button sitting inside a URL Field's input row (mirrors CopyButton):
// no border chrome, a faint glyph that brightens on hover, a visible focus ring.
export const Root = styled.button`
  display: inline-grid;
  place-items: center;
  flex: 0 0 auto;
  /* No VERTICAL padding: the button's height must stay at the icon height (16px), which is
     <= the Field input's text line-box, so mounting/unmounting it as the URL crosses validity
     never grows or jitters the input row, and the URL rows stay aligned with the sibling
     fields. Horizontal padding gives the hover/tap target its width. */
  padding: 0 6px;
  border: none;
  border-radius: 7px;
  background: transparent;
  color: ${COLORS.textFaint};
  line-height: 0;
  cursor: pointer;
  transition:
    background ${ANIM.INTERACT_MS}ms,
    color ${ANIM.INTERACT_MS}ms;

  &:hover {
    background: ${COLORS.hoverWash};
    color: ${COLORS.textMuted};
  }

  &:focus-visible {
    outline: 2px solid ${COLORS.accent};
    outline-offset: 2px;
  }
`;
